import { render } from "./SliderElement.vue?vue&type=template&id=21e6c8a4"
import script from "./SliderElement.vue?vue&type=script&lang=js"
export * from "./SliderElement.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kl_keepjoy_work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__